var backToTop = document.querySelector(".k-back-to-top-box");

window.addEventListener("scroll", function(e)
{
    if(window.pageYOffset > 384 && !backToTop.classList.contains("show"))
        backToTop.classList.add("show");
    else if(window.pageYOffset <= 384 && backToTop.classList.contains("show"))
        backToTop.classList.remove("show");
});